import React from 'react';
import i18next from 'i18next';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import InvoicesView from './InvoicesView';

import buttons from './InvoicesButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('invoices'),
	routes: [
		{
			path: 'invoices/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'invoices'),
			element: (
				<ViewPage
					key="invoices/view"
					module="invoices"
					content={{ type: 'tabs', tabs: InvoicesView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
